﻿/*global $, checkMiniProfile, console, getPersonAjaxUrlPrefix, miniProfColorPref, miniProfRoleText, miniProfUrl, treeOwnerAndRoleHtml, treeOwnerAndRoleCallout, treeOwnerAndRoleCalloutTrigger, showingMiniProfCallout */
/****************************************
	mini-profile.js
*****************************************/
/* Globals */
var treeOwnerAndRoleHtml,
	treeOwnerAndRoleCallout,
	treeOwnerAndRoleCalloutTrigger,
	showingMiniProfCallout = false;
function checkMiniProfile() {
	'use strict';
	/* Reset */
	if (showingMiniProfCallout === true) {
		showingMiniProfCallout = false;
		$('#treeOwnerAndRoleCalloutTrigger').remove();
		$(treeOwnerAndRoleHtml).appendTo('.pageCrumbs');
	}
	/* Check */
	if (parseInt($('.pageCrumbs ~ .icon').offset().left) - parseInt($('.pageCrumbs').css('width')) < 30) {
		/* Doesn't Fit */
		showingMiniProfCallout = true;
		$('.treeOwnerAndRole').remove();
		$(treeOwnerAndRoleCalloutTrigger)
			.appendTo('.pageCrumbs')
			.on('click', function () {
				var $this = $(this);
				if (!$this.data('calloutInstance')) {
					$this.callout({
						'classes': 'treeOwnerAndRole',
						'content': treeOwnerAndRoleCallout
					});
					$this.callout('open');
				}
			});
	} else {
		/* Fits */
		showingMiniProfCallout = false;
		$('.treeOwnerAndRoleHidden').removeClass('treeOwnerAndRoleHidden');
	}
}
/* On Ready */
$(function () {
	'use strict';
	$.ajax({
		url: getPersonAjaxUrlPrefix() + miniProfUrl,
		type: 'GET',
		dataType: 'json',
		cache: false,
		contentType: 'application/json',
		success: function (response) {
			if (!response.HasError) {
				/* Set up the mini profile */
				var miniProfUserCardImg,
					miniProfUserCardImgMobile,
					miniProfUserName = response.UserName,
					miniProfileUrl = response.ProfileUrl,
					miniProfRole = miniProfRoleText;
				if (miniProfRole) {
					miniProfRole = '<span class="yourRoleText"><span>&bull;</span>' + miniProfRole + '</span>';
				}
				if (response.AvatarUrl !== 'undefined' && response.AvatarUrl !== '') {
					var miniProfAvatarUrl = response.AvatarUrl,
						hasMaxWidth = 'maxWidth',
						hasMaxHeight = 'maxHeight';
					if (miniProfAvatarUrl.indexOf(hasMaxWidth) === -1 || miniProfAvatarUrl.indexOf(hasMaxHeight) === -1) {
						miniProfAvatarUrl = response.AvatarUrl + '&maxWidth=96&maxHeight=96';
					}
					/* Accessibility: Alt text is redundent text on image when on desktop but is needed when on mobile */
					miniProfUserCardImg = '<span class="userCardImg userCardImgCenter miniProfileImg" style="background-image:url(' + miniProfAvatarUrl + ')"><img alt="" src="' + miniProfAvatarUrl + '" /></span>';
					miniProfUserCardImgMobile = '<span class="userCardImg userCardImgCenter miniProfileImg" style="background-image:url(\'' + miniProfAvatarUrl + '\')"><img alt="' + miniProfUserName + '" src="' + miniProfAvatarUrl + '" /></span>';
				} else {
					/* Accessibility: Visually hidden text is needed for mobile but not desktop */
					miniProfUserCardImg = '<span class="userCardImg icon iconPerson"></span>';
					miniProfUserCardImgMobile = '<span class="userCardImg icon iconPerson"><span class="hideVisually">' + miniProfUserName + ' ' + miniProfRole + '</span></span>';
				}
				/* Create HTML and Callout for the Tree Owner and Role */
				treeOwnerAndRoleHtml =
					'<span class="treeOwnerAndRole treeOwnerAndRoleHidden">' +
						'<a class="userCard userCardInline userCardSize2 noTopSpacing" href="' + miniProfileUrl + '">' +
							miniProfUserCardImg +
							'<span class="userCardContent">' +
								'<span class="userCardComment link' + miniProfColorPref + '">' + miniProfUserName + '</span>' +
							'</span>' +
						'</a>' +
						miniProfRole +
					'</span>';
				treeOwnerAndRoleCallout =
					'<span class="treeOwnerAndRole">' +
						'<a class="userCard userCardInline userCardSize2 noTopSpacing" href="' + miniProfileUrl + '">' +
							miniProfUserCardImg +
							'<span class="userCardContent">' +
								'<span class="userCardComment link">' + miniProfUserName + '</span>' +
							'</span>' +
						'</a>' +
						miniProfRole +
					'</span>';
				treeOwnerAndRoleCalloutTrigger = '<button class="treeOwnerAndRole userCard userCardStacked userCardSize2 noTopSpacing link calloutTriggerNoArrow" id="treeOwnerAndRoleCalloutTrigger" type="button">' + miniProfUserCardImgMobile + '</button>';
				/* Append the HTML in a hidden state. */
				$(treeOwnerAndRoleHtml).appendTo('.pageCrumbs');
				/* In the hidden state check if it fits. */
				checkMiniProfile();
				if (response.TreeName) {
					var $ptn = $('#personTreeName');
					if ($ptn.length > 0) {
						$ptn.html(response.TreeName);
					}
				}
			}
		},
		error: function (msg) {
			console.log(msg);
		}
	});
});